<template>
   <div id="payment-choices-tab-wrapper">
      <ul id="payment-methods-wrapper">
         <template v-for="(paymentChoice, index) in paymentChoices">
            <li :key="index" @click="changePaymentType(paymentChoice.paymentType)">
               <div class="payment-method" :class="paymentChoice.paymentType == paymentType ? 'active-payment-method' : ''">
                  <template v-if="paymentChoice.paymentType == 1 || paymentChoice.paymentType == 2">
                     <img :src="require(`@/assets/images/${label(paymentChoice.paymentType)}_${$i18n.locale}.svg`)" />
                  </template>
                  <template v-else>
                     <img :src="require(`@/assets/images/${label(paymentChoice.paymentType)}.svg`)" />
                  </template>
               </div>
            </li>
         </template>
      </ul>

      <div v-if="isMandatorySSRMissing" class="mandatory-ssr-warning">
         <Icon name="alert-circle" />
         <span>{{ $t("PaymentChoices_msgMandatorySSRMissing") }}</span>
      </div>

      <ul id="payment-tabs-wrapper" :class="{ disabled: isMandatorySSRMissing }">
         <template v-for="(paymentChoice, index) in paymentChoices">
            <li v-if="paymentChoice.paymentType == paymentType" :key="index">
               <PaymentChoiceItem
                  :isBalanceUpdate="isBalanceUpdate"
                  :paymentChoice="paymentChoice"
                  @updateAmount="handlerUpdateAmount"
                  @updateNote="handlerUpdateNote"
                  @click="handleClick"
                  ref="paymentChoiceItem"
                  :partialPaymentEnabled="partialPaymentEnabled"
                  :partialPaymentModel="partialPaymentModel"
                  :isChecked="isChecked"
                  @toggleChange="sendToggleChange"
                  :partialPaymentOrderDetailModel="partialPaymentOrderDetailModel" />
            </li>
         </template>
      </ul>
   </div>
</template>

<script>
import PaymentChoiceItem from "@/components/structural/payment/PaymentChoiceItem.vue";
import Icon from "@/components/atoms/Icon.vue";

export default {
   name: "PaymentChoices",
   components: {
      PaymentChoiceItem,
      Icon,
   },
   props: {
      objKey: String,
      paymentChoices: Array,
      isBalanceUpdate: Boolean,
      isHeadless: Boolean,
      hidePrevBtn: Boolean,
      warning: [Object, String],
      partialPaymentEnabled: Boolean,
      partialPaymentModel: Object,
      isChecked: Boolean,
      partialPaymentOrderDetailModel: Object,
      isMandatorySSRMissing: Boolean,
   },
   data() {
      return {
         paymentType: Number,
         loadingWithSpinner: false,
      };
   },
   created() {
      this.paymentType = this.paymentChoices[0]?.paymentType;
   },

   methods: {
      sendToggleChange(isChecked) {
         this.$emit("toggleChange", isChecked);
      },
      label(type) {
         switch (type) {
            case undefined:
               return "cari";
            case 0:
               return "cari";
            case 1:
               return "cari";
            case 2:
               return "creditcard";
            case 3:
               return "creditcard";
            case 4:
               return "klarna";
            case 5:
               return "ideal";
         }
         return "";
      },
      changePaymentType(newPaymentType) {
         const self = this;
         self.paymentType = newPaymentType;
      },
      validate() {
         let result = null;
         if (this.paymentType == 2) result = this.$refs.cc[0].validate();
         return result;
      },
      handleClick(data) {
         this.$emit("click", data);
      },
      handlerUpdateAmount(data) {
         this.$emit("updateAmount", data);
      },
      handlerUpdateNote(data) {
         this.$emit("updateNote", data);
      },
   },
};
</script>

<style lang="scss" scoped>
#payment-choices-tab-wrapper {
   padding: 0;
   width: 100%;
   @media (min-width: 768px) {
      padding: 1rem;
      width: 736px;
   }

   ul#payment-methods-wrapper {
      display: flex;
      flex-direction: row;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      @media (max-width: 576px) {
         display: grid;
         grid-template-columns: repeat(2, 1fr);
      }
      @media (min-width: 800px) and (max-width: 990px) {
         display: grid;
         grid-template-columns: repeat(2, 1fr);
      }

      li {
         display: inline-block;
         margin: 0 0.125rem;
         width: calc(152px + 16px);
         height: calc(92px + 16px);

         .payment-method {
            width: 152px;
            height: 92px;
            box-sizing: content-box;
            margin: 0 !important;
            padding: 0 !important;
            cursor: pointer;

            img {
               border: 8px solid transparent;
               border-radius: 24px;
            }

            &.active-payment-method {
               img {
                  border: 8px solid var(--basket-teal);
               }
            }
         }
      }
   }

   .mandatory-ssr-warning {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      margin-top: 1.5rem;
      background-color: color-mix(in srgb, var(--orange-100), transparent 65%);
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
      border: 1.5px solid var(--orange-200);
      opacity: 0;
      animation: fadeIn 0.5s ease-out 0s forwards, bounce 0.4s ease-in-out 2.5s 3 forwards;

      .ui-icon {
         width: 1.25rem;
         height: 1.25rem;

         ::v-deep svg {
            max-width: 1.25rem;
            max-height: 1.25rem;
         }

         ::v-deep svg path,
         ::v-deep svg circle {
            stroke: var(--orange-600);
         }
      }

      span {
         color: var(--orange-600);
         font-size: var(--small);
         line-height: 1.35rem;
         font-weight: 500;
      }
   }

   @keyframes fadeIn {
      from {
         opacity: 0;
         transform: translateY(-10px);
      }
      to {
         opacity: 1;
         transform: translateY(0);
      }
   }

   @keyframes bounce {
      0%,
      100% {
         transform: translateY(0);
      }
      50% {
         transform: translateY(-5px);
      }
   }

   ul#payment-tabs-wrapper {
      margin-top: 2rem;

      &.disabled {
         pointer-events: none;
         opacity: 0.4;
         filter: grayscale(0.5);
         user-select: none;
      }
   }
}
</style>

<style lang="scss" scoped>
.payment-choices-tab-wrapper3 {
   width: 100%;
   @media (min-width: 576px) {
      flex-direction: row;
   }
   .payment-choices-tab-inner {
      .payment-choices-tabs {
         margin-bottom: 24px;
         border: none;
         display: flex;
         flex-direction: row;

         @media (min-width: 576px) {
            flex-direction: row;
         }
         .payment-choices-tab-list-item {
            @media (min-width: 576px) {
            }
            @media (min-width: 992px) {
               margin-right: 0.5rem;
            }

            &:last-child {
               margin-right: 0;
            }
            & > a.nav-link {
               display: flex;
               margin: 0 !important;
               padding: 0 !important;
               border: 0 !important;

               &.active {
                  & > img {
                     border: 8px solid var(--teal-200);
                  }
               }
               & > img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border: 8px solid transparent;
                  border-radius: 24px;
               }

               &#CARI-tab {
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  background-color: var(--blue-500);
                  font-size: 20px;
                  text-transform: uppercase;
                  color: white;
               }
            }
         }
      }
      .payment-choices-tab-content {
         width: 100%;

         @media (min-width: 576px) {
         }
         .payment-choices-tab-content-item {
            .payment-choices-tab-content-item-inner {
               width: 100%;
               ::v-deep .credit-card-wrapper,
               ::v-deep .balance-update-form-wrapper {
                  width: 100%;
               }

               ::v-deep .gts-alert {
                  margin: 24px 0;
               }
            }
         }
      }
   }
}
</style>
